import { render, staticRenderFns } from "./ModalStatusHistorico.vue?vue&type=template&id=686eea1e"
import script from "./ModalStatusHistorico.vue?vue&type=script&lang=js"
export * from "./ModalStatusHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports